import { buttonVariants, cn } from '@napaicp/ui'
import { BookOpenText, Cpu, Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const LINKS = [
  { key: 'about', to: '/about', icon: Info },
  { key: 'howto', to: '/howto', icon: BookOpenText },
  { key: 'architecture', to: '/architecture', icon: Cpu },
] as const

/**
 * Secondary quick links to the platform's other public pages (about, howto,
 * architecture) — deliberately excludes the admin guide, which stays scoped
 * to the signed-in admin consoles rather than the public homepage.
 */
export function LearnMoreSection() {
  const { t } = useTranslation(['home', 'nav'])

  return (
    <section className="flex flex-col gap-4 pt-1 pb-4 md:pt-2 md:pb-6">
      <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">
        {t('learnMore.heading')}
      </h2>
      <div className="flex flex-wrap gap-3">
        {LINKS.map(({ key, to, icon: Icon }) => (
          <Link
            key={key}
            to={to}
            className={cn(buttonVariants({ variant: 'outline', size: 'lg' }))}
          >
            <Icon className="size-4" aria-hidden="true" />
            {t(`nav:${key}`)}
          </Link>
        ))}
      </div>
    </section>
  )
}
